import { CoreMyntModal } from '@components/modals/CoreMyntModal'
import { Button, Stack, Typography } from '@mui/material'
import FeatherIcon from 'feather-icons-react'
import { BorderedStack } from '../BorderedStack'
import type { ConfirmableProps } from './confirmable'

export interface ConfirmModalProps<T> extends ConfirmableProps<T> {
  connections: number
}

export const ConfirmModal = <T,>({ open, data, title, actionText, onClose, onConfirm, connections, changes }: ConfirmModalProps<T>) => {
  return (
    <CoreMyntModal
      open={open}
      onClose={onClose}
      title={title}
      wrapperProps={{ sx: { maxWidth: 500 } }}
      actions={(Wrapper) => (
        <Wrapper>
          <Button onClick={onClose}>No</Button>
          <Button data-testid="confirm-button" variant="contained" onClick={() => onConfirm(data)}>
            {actionText}
          </Button>
        </Wrapper>
      )}
    >
      <Stack
        sx={{
          gap: 2,
          flex: 1,
        }}
      >
        <Typography variant="p2Regular" color="textSecondary">
          These changes will apply to {connections} customers. Are you sure you want to continue? This action cannot be undone.
        </Typography>
        {changes.length > 0 && (
          <BorderedStack
            sx={{
              padding: 2,
              flex: 1,
            }}
          >
            {changes.map(({ before, after }) => (
              <Stack
                direction="row"
                key={after.name}
                sx={{
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography color="textSecondary" variant="p3SemiBold">
                  {after.name}
                </Typography>
                <Stack
                  direction="row"
                  sx={{
                    alignItems: 'center',
                    gap: 0.5,
                  }}
                >
                  {before && (
                    <Typography variant="p2Regular" color="textSecondary">
                      {String(before?.value)}
                    </Typography>
                  )}
                  <Typography
                    variant="p2Regular"
                    color="textSecondary"
                    sx={{
                      lineHeight: 0,
                    }}
                  >
                    <FeatherIcon icon="chevron-right" />
                  </Typography>
                  <Typography variant="p2SemiBold" color="textPrimary">
                    {String(after.value)}
                  </Typography>
                </Stack>
              </Stack>
            ))}
          </BorderedStack>
        )}
      </Stack>
    </CoreMyntModal>
  )
}
